(() => {
  'use strict';

  const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

  const getHeaderHeight = () => {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .trim();

    return Number.parseFloat(value) || 0;
  };

  const closeDesktopGroups = (root) => {
    root
      .querySelectorAll(
        '.f2w-fightbase-navigation__desktop .f2w-fightbase-navigation__group'
      )
      .forEach((group) => {
        group.removeAttribute('open');
      });
  };

  const closeMobileGroups = (root) => {
    root
      .querySelectorAll(
        '.f2w-fightbase-navigation__mobile-menu[open], .f2w-fightbase-navigation__mobile-group[open]'
      )
      .forEach((group) => {
        group.removeAttribute('open');
      });
  };

  const removeStickyState = (root, placeholder) => {
    root.classList.remove(
      'is-desktop-sticky',
      'is-mobile-sticky'
    );

    root.style.display = '';
    placeholder.style.height = '';
    closeDesktopGroups(root);
  };

  const updateStickyState = (root, placeholder) => {
    const stickyOffset = getHeaderHeight();
    const isDesktop = desktopMediaQuery.matches;
    const usesMobileReveal = root.classList.contains(
      'f2w-fightbase-navigation--reveal-after-header'
    );
    const revealAnchor = root.previousElementSibling;
    const hasRevealAnchor =
      usesMobileReveal &&
      !isDesktop &&
      revealAnchor?.classList.contains('f2w-event-directory__header');

    if (hasRevealAnchor) {
      const shouldReveal =
        revealAnchor.getBoundingClientRect().bottom <= stickyOffset;

      if (!shouldReveal) {
        root.classList.remove(
          'is-desktop-sticky',
          'is-mobile-sticky'
        );

        root.style.display = 'none';
        placeholder.style.height = '';
        closeMobileGroups(root);
        return;
      }

      root.style.display = '';
      root.classList.add('is-mobile-sticky');
      root.classList.remove('is-desktop-sticky');
      placeholder.style.height = `${root.offsetHeight}px`;
      return;
    }

    root.style.display = '';

    const placeholderTop = placeholder.getBoundingClientRect().top;
    const shouldStick = placeholderTop <= stickyOffset;

    if (!shouldStick) {
      removeStickyState(root, placeholder);
      return;
    }

    placeholder.style.height = `${root.offsetHeight}px`;

    if (isDesktop) {
      root.classList.add('is-desktop-sticky');
      root.classList.remove('is-mobile-sticky');
    } else {
      root.classList.add('is-mobile-sticky');
      root.classList.remove('is-desktop-sticky');
    }
  };

  const initializeFightBaseNavigation = () => {
    const roots = document.querySelectorAll(
      '[data-f2w-fightbase-navigation]'
    );

    roots.forEach((root) => {
      if (root.dataset.f2wNavigationReady === 'true') {
        return;
      }

      root.dataset.f2wNavigationReady = 'true';

      const desktopGroups = root.querySelectorAll(
        '.f2w-fightbase-navigation__desktop .f2w-fightbase-navigation__group'
      );

      desktopGroups.forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) {
            return;
          }

          desktopGroups.forEach((otherGroup) => {
            if (otherGroup !== group) {
              otherGroup.removeAttribute('open');
            }
          });
        });
      });

      const placeholder = document.createElement('div');

      placeholder.className =
        'f2w-fightbase-navigation__sticky-placeholder';

      placeholder.setAttribute('aria-hidden', 'true');

      root.parentNode.insertBefore(placeholder, root);

      const update = () => {
        updateStickyState(root, placeholder);
      };

      window.addEventListener('scroll', update, {
        passive: true
      });

      window.addEventListener('resize', update, {
        passive: true
      });

      if (typeof desktopMediaQuery.addEventListener === 'function') {
        desktopMediaQuery.addEventListener('change', update);
      } else {
        desktopMediaQuery.addListener(update);
      }

      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeFightBaseNavigation,
      { once: true }
    );
  } else {
    initializeFightBaseNavigation();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeFightBaseNavigation
  );
})();
